import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { Theme } from 'theme/contracts';

export function useTheme(): Theme {
  //@ts-ignore
  return useContext(ThemeContext);
}
